import type { BrandDraft } from '../../hooks/useCreateBrand';
import { Field } from '../ui/field';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

/** The brand create form, shared by the standalone modal and the inline step. */
export function BrandFormFields({
	value,
	onChange,
	autoFocus = false,
}: {
	value: BrandDraft;
	onChange: (next: BrandDraft) => void;
	autoFocus?: boolean;
}) {
	const set = (patch: Partial<BrandDraft>) => onChange({ ...value, ...patch });

	return (
		<div className="flex flex-col gap-5">
			<Field label="Brand name" required>
				<Input
					value={value.name}
					onChange={(e) => set({ name: e.target.value })}
					placeholder="e.g. Main Brand"
					autoFocus={autoFocus}
				/>
			</Field>

			<Field label="Description">
				<Textarea
					value={value.description}
					onChange={(e) => set({ description: e.target.value })}
					placeholder="A short description of this brand"
					rows={3}
				/>
			</Field>

			<Field label="Website">
				<Input
					value={value.website}
					onChange={(e) => set({ website: e.target.value })}
					placeholder="https://brand.com"
				/>
			</Field>
		</div>
	);
}
